import { EntityFeedbackResponseContent } from '@backstage-community/plugin-entity-feedback';
import { PluginTabWrapper } from './PluginTabWrapper';

export const FeedbackTab = () => (
  <PluginTabWrapper>
    <EntityFeedbackResponseContent />
  </PluginTabWrapper>
);
